<!-- <div class="loader-overlay" *ngIf="loaderService.loading$ | async">
  <div class="spinner">
    <div class="ring"></div>
    <div class="ring"></div>
    <div class="ring"></div>
  </div>
  <p class="loader-text">Loading, please wait...</p>
</div> -->


<div class="loader-overlay" *ngIf="loaderService.loading$ | async">
  <div class="loader-box">
    <div class="logo-zoom-wrap">
      <img src="assets/NEXGEN Logo final.png" alt="NEXGEN" class="loader-logo" />
    </div>
    <div class="gold-bar-track">
      <div class="gold-bar-fill"></div>
    </div>
    <div class="loading-label">Loading</div>
  </div>
</div>